<div class="search-confirm-dialog">
    <h1 mat-dialog-title><strong>{{ data?.title || 'Confirmation' }}</strong></h1>
    <div mat-dialog-content>
        <p><span [innerHTML]="data?.text"></span></p>
    </div>
    <hr/>
    <div mat-dialog-actions class="float-right">
        <button mat-button (click)="onCancelConfirm()" [hidden]="data?.hideCancel">{{data?.cancelText || 'Cancel'}}</button>
        <button mat-button [mat-dialog-close]="dataObj.closeModal" cdkFocusInitial>{{data?.okText || 'Yes'}}</button>
    </div>
</div>